import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixThumbDownIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M9.31218 17.5368L10.2111 13.8334H4.97061C4.69151 13.8334 4.41625 13.7684 4.16663 13.6436C3.917 13.5188 3.69986 13.3376 3.5324 13.1143C3.36495 12.891 3.25178 12.6318 3.20185 12.3572C3.15192 12.0826 3.16662 11.8002 3.24476 11.5323L5.33915 4.34126C5.44806 3.96784 5.67515 3.63981 5.98634 3.40643C6.29752 3.17304 6.67601 3.04687 7.06499 3.04688H19.1998C19.6766 3.04688 20.1339 3.23628 20.471 3.57343C20.8082 3.91057 20.9976 4.36784 20.9976 4.84463V12.0356C20.9976 12.5124 20.8082 12.9697 20.471 13.3069C20.1339 13.644 19.6766 13.8334 19.1998 13.8334H16.7189C16.3845 13.8336 16.0567 13.9271 15.7725 14.1033C15.4882 14.2796 15.2588 14.5316 15.1099 14.8312L12.0088 21.0244C11.5849 21.0192 11.1677 20.9182 10.7883 20.7291C10.4089 20.5399 10.0772 20.2675 9.81789 19.9321C9.55858 19.5967 9.37842 19.2071 9.29085 18.7923C9.20328 18.3775 9.21057 17.9483 9.31218 17.5368Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.5029 13.8334V3.04688"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
